import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class KeyNumberService {
  private api = inject(ApiService);

  create(json: any) { return this.api.post('/keyNumber/create', json); }
  exists(pre: string, suf: string, start: number, end: number) {
    return this.check('exists', pre, suf, start, end);
  }
  inUse(pre: string, suf: string, start: number, end: number) {
    return this.check('in_use', pre, suf, start, end);
  }

  private async check(kind: 'exists' | 'in_use', pre: string, suf: string, start: number, end: number): Promise<boolean> {
    const response = await firstValueFrom(this.api.getRaw<any>(`/keyNumber/${kind}/${encodeURIComponent(pre || '*')}/${encodeURIComponent(suf || '*')}/${start}/${end}`));
    if (response?.success !== true || typeof response.result !== 'boolean') throw new Error('入退館キー番号の確認に失敗しました');
    return response.result;
  }
  remove(json: any) { return this.api.post('/keyNumber/remove', json); }
  update(json: any) { return this.api.post('/keyNumber/update', json); }
  release(json: any) { return this.api.post('/keyNumber/release', json); }
}
